import { render, staticRenderFns } from "./DefaultContainer.vue?vue&type=template&id=a122549a&scoped=true&"
import script from "./DefaultContainer.vue?vue&type=script&lang=ts&"
export * from "./DefaultContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultContainer.vue?vue&type=style&index=0&id=a122549a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a122549a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VFooter,VMain,VOverlay,VProgressCircular})
